import { useCallback, useEffect, useRef, useState } from "react";
import { useAuth } from "../../components/context/Auth";
import {
  DispatchDownloadIcon,
  DispatchReloadIcon,
} from "../../components/icons/Icon";
import Button from "../../components/updatedComponents/Dealers/Button";
import SlidingFilter2 from "../../components/updatedComponents/Dealers/SlidingFilter2";
import Pagination2 from "../../components/updatedComponents/FormComponents/Pagination2";
import TopTabBar from "../../components/updatedComponents/Tanolet/TopTabBar";
import styles from "./DispatchDashboard.module.css";
import InputTypedate from "../../components/updatedComponents/FormComponents/InputTypedate";
import DealerStatusCard from "../../components/updatedComponents/Dealers/DealerStatusCard";
import ToggleSearchBar from "../../components/updatedComponents/FormComponents/ToggleSearchBar";
import DropDown from "../../components/updatedComponents/FormComponents/DropDown";
import Skeleton from "../../components/updatedComponents/Skeleton/Skeleton";
import NoDataFound from "../../components/updatedComponents/NoDataFound/NoDataFound";
import { TemplateNotFound } from "../../components/icons/Icon2";
import fetchData from "../../APIsControll/apiControll";
import { socket, SocketConnected } from "../../Socket/socket";
import { useNavigate } from "react-router-dom";
import {
  formatDateTime,
  getStatusColor,
  LastActionCell,
} from "../../Utils/Utils";
import { useDispatch, useSelector } from "react-redux";
import {
  setFilter,
  setPagination,
  setUi,
} from "../../store/slices/dispatch/DispatchSlice";
import useTableHeight from "../../hooks/useTableHeight";
import {
  daysData,
  dispatchHeader,
  orderTypeData,
} from "../../constants/constants";
import useDebounce from "../../hooks/useDebounce";

const DispatchDasboard = () => {
  const { mode, managerId, designations, designation } = useAuth();

  const { filter, pagination, ui } = useSelector((r) => r.dispatch);
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const tableRef = useRef(null);

  const limit = useTableHeight(tableRef);

  const debouncedKeyword = useDebounce(filter.keyword, 700);

  const [dispatchFilters, setdispatchFilters] = useState([]);
  const [warehouses, setWarehouses] = useState([]);
  const [managers, setManagers] = useState([]);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [reFetch, setRefetch] = useState(false);

  const getDispatchOrders = useCallback(async () => {
    if (
      filter.daysTab === "period" &&
      (filter.startDate === "" || filter.endDate === "")
    )
      return;

    const apiData = {
      managerId: managerId,
      keyword: debouncedKeyword,
      orderStatus: filter.status,
      warehouseId: filter.selectedWarehouseId,
      disPatchManagerId: filter.selectedManagerID,
      day: filter.daysTab === "period" ? "" : filter.daysTab,
      startDate: filter.startDate,
      endDate: filter.endDate,
    };

    try {
      setLoading(true);
      const result = await fetchData(
        `dispatch/allOrders?page=${pagination.page}&limit=${limit}`,
        apiData,
      );
      if (result.status === "success") {
        setLoading(false);
        setData(result.data);
        setManagers(
          result.managers.map((m) => ({
            label: m.name,
            value: m.managerId,
          })),
        );
        setWarehouses(
          result.warehouses.map((m) => ({
            label: m.warehousename,
            value: m.warehouseId,
          })),
        );
        setdispatchFilters(result.orders);
        dispatch(setPagination({ pages: result.pages }));
      }

      if (result.status === "failed") {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, [
    filter.daysTab,
    filter.startDate,
    filter.endDate,
    debouncedKeyword,
    filter.status,
    filter.selectedWarehouseId,
    filter.selectedManagerID,
    managerId,
    pagination.page,
    limit,
    dispatch,
  ]);

  useEffect(() => {
    if (limit === 1) return;

    getDispatchOrders();
  }, [
    filter.daysTab,
    filter.startDate,
    filter.endDate,
    debouncedKeyword,
    filter.status,
    filter.selectedWarehouseId,
    filter.selectedManagerID,
    managerId,
    pagination.page,
    limit,
    dispatch,
    getDispatchOrders,
    reFetch,
  ]);

  useEffect(() => {
    if (filter.status === "All") {
      if (!managerId || !designation) {
        console.warn(
          "useEffect exited early — missing managerId or designation",
        );
        return;
      }

      const managerWarehouses =
        JSON.parse(localStorage.getItem("warehouse")) || [];

      SocketConnected({
        socketUserId: `${managerId}`,
        role: designation,
        warehouseNames: managerWarehouses,
      });

      const handleAllOrders = (payload) => {
        const ordersArray =
          payload?.allOrders ||
          payload?.allOrder?.data ||
          payload?.allorder?.data ||
          payload?.allorders?.data ||
          payload?.allorders ||
          payload?.data ||
          (Array.isArray(payload) ? payload : null);

        if (
          !ordersArray ||
          !Array.isArray(ordersArray) ||
          ordersArray.length === 0
        ) {
          console.warn("⚠️ No orders found in socket payload");
          return;
        }

        setData((prev = []) => {
          let existingMap = new Map(prev.map((o) => [String(o.orderId), o]));

          ordersArray.forEach((incoming, idx) => {
            if (
              !incoming ||
              incoming.orderId === undefined ||
              incoming.orderId === null
            ) {
              console.warn(`Skipping invalid order at index ${idx}:`, incoming);
              return;
            }

            const inOrderIdStr = String(incoming.orderId);
            const myManagerId = String(managerId);

            const managerWarehouses =
              JSON.parse(localStorage.getItem("warehouse")) || [];
            let dmList = [];

            if (Array.isArray(incoming.dmId)) {
              dmList = incoming.dmId.map(String);
            } else if (incoming.dmId !== undefined && incoming.dmId !== null) {
              dmList = [String(incoming.dmId)];
            }

            const hasDmId = dmList.length > 0;
            const incomingWarehouses = payload.warehousename || [];

            const isWarehouseMatched = managerWarehouses.some((wh) =>
              incomingWarehouses.includes(wh),
            );

            const assignedManagerId =
              incoming.assignedManagerId !== undefined
                ? String(incoming.assignedManagerId)
                : null;
            const incomingManagerId =
              incoming.managerId !== undefined
                ? String(incoming.managerId)
                : null;

            const isForThisManager =
              designation === "superadmin" ||
              (assignedManagerId && assignedManagerId === myManagerId) ||
              (incomingManagerId && incomingManagerId === myManagerId) ||
              (hasDmId && dmList.includes(myManagerId)) ||
              (!hasDmId && isWarehouseMatched);

            if (isForThisManager) {
              const existingOrder = existingMap.get(inOrderIdStr);
              const updatedOrder = { ...(existingOrder || {}), ...incoming };

              if (!existingOrder) {
                existingMap.delete(inOrderIdStr);
                existingMap = new Map([
                  [inOrderIdStr, updatedOrder],
                  ...existingMap,
                ]);
              } else {
                existingMap.set(inOrderIdStr, updatedOrder);
              }
            } else {
              existingMap.delete(inOrderIdStr);
            }
          });

          const finalArray = Array.from(existingMap.values());
          return finalArray;
        });
      };

      try {
        socket.off("allorders", handleAllOrders);
      } catch (e) {
        console.error("Error while removing previous socket listener:", e);
      }

      socket.on("allorders", handleAllOrders);

      return () => {
        try {
          socket.off("allorders", handleAllOrders);
        } catch (e) {
          console.error("Error while cleaning up socket listener:", e);
        }
      };
    }
  }, [designation, filter.status, managerId]);

  const handleDayChange = (label) => {
    const selectedFilter = daysData.find((item) => item.label === label);
    const newDayTab = selectedFilter?.value || "today";

    dispatch(setFilter({ daysTab: newDayTab }));

    if (newDayTab !== "period") {
      setdispatchFilters([]);
      dispatch(setPagination({ pages: [] }));
      dispatch(setFilter({ startDate: "" }));
      dispatch(setFilter({ endDate: "" }));
    }
  };

  const handleVoucherChange = (voucherOptions, v) => {
    const selectedFilter = voucherOptions.find((item) => item === v);
    dispatch(setFilter({ voucherTab: selectedFilter }));
  };

  const resetAllStates = () => {
    dispatch(setPagination({ page: 1 }));
    dispatch(setPagination({ pages: 1 }));
    dispatch(setFilter({ daysTab: "today" }));
    dispatch(setFilter({ startDate: "" }));
    dispatch(setFilter({ endDate: "" }));
    dispatch(setFilter({ status: "All" }));
    dispatch(setFilter({ selectedWarehouseId: "" }));
    dispatch(setFilter({ selectedManagerID: null }));
    dispatch(setFilter({ keyword: "" }));
    dispatch(setUi({ isSearchBarOpen: false }));

    setLoading(false);
    setRefetch((prev) => !prev);
  };

  const routeName = "Dispatch";

  const dispatchStatus = [
    {
      status: "All",
      label: "All",
      count: dispatchFilters[0]?.count || 0,
      allCount: dispatchFilters[0]?.prevCount || 0,
      amount: dispatchFilters[0]?.amount || 0,
    },
    {
      status: "New Order",
      label: "New Order",
      count: dispatchFilters[1]?.count || 0,
      allCount: dispatchFilters[1]?.prevCount || 0,
      amount: dispatchFilters[1]?.amount || 0,
    },
    {
      status: "Cancelled",
      label: "Cancelled",
      count: dispatchFilters[2]?.count || 0,
      allCount: dispatchFilters[2]?.prevCount || 0,
      amount: dispatchFilters[2]?.amount || 0,
    },
    {
      status: "In Progress",
      label: "In Progress",
      count: dispatchFilters[3]?.count || 0,
      allCount: dispatchFilters[3]?.prevCount || 0,
      amount: dispatchFilters[3]?.amount || 0,
    },
    {
      status: "Packed",
      label: "Packed",
      count: dispatchFilters[4]?.count || 0,
      allCount: dispatchFilters[4]?.prevCount || 0,
      amount: dispatchFilters[4]?.amount || 0,
    },
    {
      status: "Pending",
      label: "Pending",
      count: dispatchFilters[5]?.count || 0,
      allCount: dispatchFilters[5]?.prevCount || 0,
      amount: dispatchFilters[5]?.amount || 0,
    },
    {
      status: "Dispatched",
      label: "Dispatched",
      count: dispatchFilters[6]?.count || 0,
      allCount: dispatchFilters[6]?.prevCount || 0,
      amount: dispatchFilters[6]?.amount || 0,
    },
    {
      status: "Delivery Pending",
      label: "Delivery Pending",
      count: dispatchFilters[7]?.count || 0,
      allCount: dispatchFilters[7]?.prevCount || 0,
      amount: dispatchFilters[7]?.amount || 0,
    },
    {
      status: "Completed",
      label: "Completed",
      count: dispatchFilters[8]?.count || 0,
      allCount: dispatchFilters[8]?.prevCount || 0,
      amount: dispatchFilters[8]?.amount || 0,
    },
  ];

  return (
    <div
      className={styles.dispatch}
      style={mode ? { backgroundColor: "#2C2E33", borderColor: "#2C2E33" } : {}}
    >
      <div className={styles.dispatch_top}>
        <div>
          <TopTabBar text={routeName} />
        </div>

        <div className={styles.dispatch_right}>
          <div>
            <SlidingFilter2
              itemList={daysData.map((item) => item.label)}
              setFilter={handleDayChange}
              selectedItem={
                daysData.find((item) => item.value === filter.daysTab)?.label
              }
            />
          </div>

          {filter.daysTab === "period" && (
            <>
              <div>
                <InputTypedate
                  text={"From"}
                  value={filter.startDate}
                  max={filter.endDate}
                  onChange={(e) => {
                    dispatch(setFilter({ startDate: e.target.value }));
                    if (filter.daysTab !== "period") {
                      dispatch(setFilter({ daysTab: "" }));
                    }
                    dispatch(setFilter({ status: "" }));
                  }}
                />
              </div>
              {filter.startDate !== "" && (
                <div>
                  <InputTypedate
                    text={"To"}
                    value={filter.endDate}
                    min={filter.startDate}
                    onChange={(e) => {
                      dispatch(setFilter({ endDate: e.target.value }));
                      if (filter.daysTab !== "period") {
                        dispatch(setFilter({ daysTab: "" }));
                      }
                      dispatch(setFilter({ status: "" }));
                    }}
                  />
                </div>
              )}
            </>
          )}

          <div>
            <Button
              buttonIcon={<DispatchReloadIcon />}
              buttonBgColor={"#000000"}
              buttonTextColor={"#ffffff"}
              buttonBorder={"none"}
              buttonClick={resetAllStates}
            />
          </div>

          <div>
            <Button
              buttonIcon={<DispatchDownloadIcon />}
              buttonBgColor={"#4164E3"}
              buttonTextColor={"#ffffff"}
              buttonBorder={"none"}
            />
          </div>
          <div>
            <Pagination2
              mode={mode}
              currentPage={pagination.page}
              setCurrentPage={(newPage) =>
                dispatch(setPagination({ page: newPage }))
              }
              totalPages={pagination.pages}
            />
          </div>
        </div>
      </div>

      <div>
        <div
          className={styles.dispatch_filters}
          style={
            mode ? { borderColor: "#232529", backgroundColor: "#232529" } : {}
          }
        >
          <>
            {dispatchStatus?.map((s) => (
              <div
                key={s.status}
                className={`${styles.dispatch_filter} ${
                  mode ? styles.dispatch_filter_dark : ""
                } ${
                  s.status === filter.status
                    ? mode
                      ? styles.dispatch_filter_active_dark
                      : styles.dispatch_filter_active
                    : ""
                }`}
                onClick={async () => {
                  if (s.status === filter.status) {
                    await getDispatchOrders();
                  } else {
                    dispatch(setFilter({ status: s.status }));
                    dispatch(setPagination({ page: 1 }));
                  }
                }}
              >
                <DealerStatusCard
                  statusText={s.label}
                  statusItemCount={s.count}
                  statusAllCount={s.allCount}
                  type={"dispatch"}
                  amount={s.amount}
                />
              </div>
            ))}
          </>
        </div>
      </div>

      <div className={styles.rem_filters}>
        <div className={styles.rem_filters_c}>
          <div>
            <ToggleSearchBar
              placeholder={"Search"}
              value={filter.keyword}
              onChange={(e) => {
                dispatch(setFilter({ keyword: e.target.value }));
                dispatch(setPagination({ page: 1 }));
              }}
              onToggle={(isExpanded) =>
                dispatch(setUi({ isSearchBarOpen: isExpanded }))
              }
            />
          </div>
        </div>
        <div className={styles.rem_filters_c}>
          {ui.isSearchBarOpen ? (
            <DropDown
              label={"Type"}
              listLabel={"Order"}
              options={orderTypeData.map((o) => ({ label: o, value: o }))}
              onSelect={(option) =>
                dispatch(setFilter({ voucherTab: option.value }))
              }
              onReject={() => dispatch(setFilter({ voucherTab: "Order" }))}
            />
          ) : (
            <SlidingFilter2
              itemList={orderTypeData.map((item) => item)}
              setFilter={(v) => handleVoucherChange(orderTypeData, v)}
              selectedItem={orderTypeData.find(
                (item) => item === filter.voucherTab,
              )}
            />
          )}

          {designations.includes("superadmin") && (
            <>
              <DropDown
                label={"Manager"}
                listLabel={"All"}
                options={managers}
                onSelect={(option) =>
                  dispatch(setFilter({ selectedManagerID: option.value }))
                }
                onReject={() =>
                  dispatch(setFilter({ selectedManagerID: null }))
                }
              />
              <DropDown
                label={"Warehouse"}
                listLabel={"All"}
                options={warehouses}
                onSelect={(option) =>
                  dispatch(setFilter({ selectedWarehouseId: option.value }))
                }
                onReject={() =>
                  dispatch(setFilter({ selectedWarehouseId: null }))
                }
              />
            </>
          )}
        </div>
      </div>

      <ul className={styles.dispatch_data} ref={tableRef}>
        <li
          className={`${styles.dispatch_data_header} ${
            mode ? styles.dispatch_data_header_dark : ""
          }`}
        >
          {dispatchHeader.map((h, index) => (
            <div className={styles.entry} key={`${h}-${index}`} title={h}>
              {h}
            </div>
          ))}
        </li>
        <div className={`${styles.dispatch_data_list} ${styles.rdl}`}>
          {loading ? (
            <div>
              <Skeleton
                lines={15}
                thickness={5}
                additionalStyles={{ marginBottom: "0px", marginTop: "0px" }}
              />
            </div>
          ) : (
            <>
              {!loading && data.length === 0 ? (
                <div className={styles.no_data}>
                  <NoDataFound
                    icon={<TemplateNotFound />}
                    textTitle={`No Data Found`}
                  />
                </div>
              ) : (
                <>
                  {data.map((r, index) => (
                    <div key={index}>
                      <li
                        className={`${styles.dispatch_data_row} ${
                          mode ? styles.dispatch_data_row_dark : ""
                        }
                          
                        ${
                          r.orderType === "Direct Collect"
                            ? styles.direct_collect
                            : r.orderType === "Master Order"
                              ? styles.master_order
                              : ""
                        }
                        
                        `}
                        onClick={() => {
                          navigate("/dispatch/dispatchorders/" + r.orderId);
                        }}
                      >
                        <div
                          className={styles.entry}
                          title={formatDateTime(r.orderDate)}
                        >
                          {formatDateTime(r.orderDate)}
                        </div>
                        <div className={styles.entry} title={r.orderId}>
                          {r.orderId}
                        </div>
                        <div
                          className={styles.entry}
                          title={
                            r.storeName + ", " + r.city + ", " + r.dealerId
                          }
                        >
                          {r.storeName}, {r.city}, {r.dealerId}
                        </div>
                        <div className={styles.entry} title={r.createdBy}>
                          {r.createdBy}
                        </div>
                        <div className={styles.entry} title={r.ordermanager}>
                          {r.ordermanager}
                        </div>
                        <div className={styles.entry} title={r.packinghManager}>
                          {r.packinghManager}
                        </div>
                        <div
                          className={styles.entry}
                          style={{ color: getStatusColor(r.orderType) }}
                          title={r.orderType}
                        >
                          {r.orderType}
                        </div>
                        <div className={styles.entry} title={r.methodName}>
                          {r.methodName}
                        </div>
                        <div className={styles.entry} title={r.pendingAmount}>
                          {r.pendingAmount}
                        </div>
                        <div className={styles.entry} title={r.partnerName}>
                          {r.partnerName}
                        </div>
                        <div
                          className={styles.entry}
                          style={{ color: getStatusColor(r.status) }}
                          title={r.status}
                        >
                          {r.status}
                        </div>
                        <div className={styles.entry} title={r.lastAction}>
                          <LastActionCell lastAction={r.lastAction} />{" "}
                        </div>
                      </li>
                    </div>
                  ))}
                </>
              )}
            </>
          )}
        </div>
      </ul>
    </div>
  );
};

export default DispatchDasboard;
